
import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { models as modelOptions, sizes as sizeOptions, colors as colorOptions, materials as materialOptions, manufacturing as manufacturingOptions, designs as designOptions, usage as usageOptions } from "../../assets/constant";
import {saveCarpetData} from "../../aws/DynamoDB";
import {deleteImageFromS3, uploadImageToS3} from "../../aws/S3";

export default function CarpetForm({ carpet, onClose, fetchCarpets }) {
    const [formData, setFormData] = useState({
        id: null,
        name: "",
        model: "",
        size: "",
        // massen: "",
        // color: "",
        // material: "",
        // manufacturing: "",
        // design: "",
        // usage: "",
        height: "",
        width: "",
        orgPrice: "",
        acctPrice: "",
        priceOnRequest: false,
        shortDescription: "",
        detailedDescription: "",
        images: [],
        created_time: new Date().toISOString(),
        updated_time: new Date().toISOString(),
        updated_by: "Admin",
        tags: []
    });
    const [saving, setSaving] = useState(false);


    useEffect(() => {
        if (carpet) {
            setFormData({ ...carpet });
        }
    }, [carpet]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleImageUpload = async (e) => {
        const files = Array.from(e.target.files);
        const uploadedImages = [];

        for (const file of files) {
            if (file) {
                uploadedImages.push(file);
            }
        }

        setFormData((prev) => ({
            ...prev,
            images: [...prev.images, ...uploadedImages].slice(0, 5)
        }));
    };

    const removeImage = (index) => {
        setFormData((prev) => ({
            ...prev,
            images: prev.images.filter((_, i) => i !== index)
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const idToken = localStorage.getItem("idToken"); // Ensure it's saved after user login
        if (!idToken) {
            console.error("User is not authenticated.");
            return;
        }
        setSaving(true); // ➡️ START saving

        try {
            const oldImages = carpet ? carpet.images : [];
            const newImages = formData.images;

            // ✅ Separate new images (File objects) from existing ones (URLs)
            const existingImages = newImages.filter((img) => typeof img === "string");
            const imagesToUpload = newImages.filter((img) => typeof img !== "string");

            // ✅ Upload new images
            const uploadedImageUrls = await Promise.all(imagesToUpload.map(file => uploadImageToS3(file, idToken)));

            // ✅ Final image list after uploads
            const finalImages = [...existingImages, ...uploadedImageUrls];

            // ✅ Identify and delete removed images
            const imagesToDelete = oldImages.filter(img => !finalImages.includes(img));
            await Promise.all(imagesToDelete.map((url) => deleteImageFromS3(url, idToken)));

            // ✅ Prepare updated carpet object
            const updatedCarpet = {
                ...formData,
                images: finalImages,
                updated_by: "Admin",
                updated_time: new Date().toISOString(),
                size: `${formData.width}x${formData.height}`
            };

            if (!idToken) {
                console.error("User is not authenticated.");
                return;
            }
            else {
                await saveCarpetData(updatedCarpet, idToken);
                fetchCarpets(1, true);
            }
            onClose();

        } catch (error) {
            console.error("Fehler beim Speichern:", error);
        }
        finally {
            setSaving(false); // ➡️ END saving
        }

    };


    return (
        <ModalBackdrop onClick={onClose}>
            <FormContainer onClick={(e) => e.stopPropagation()}>
                <h2>{carpet ? "Teppich bearbeiten" : "Neuer Teppich hinzufügen"}</h2>
                <form onSubmit={handleSubmit}>
                    <Label>Bilder hochladen (max. 5 Bilder)</Label>
                    <UploadButton htmlFor="carpet-images-upload">
                        Bilder auswählen
                        <HiddenFileInput
                            id="carpet-images-upload"
                            type="file"
                            multiple
                            accept="image/*"
                            onChange={handleImageUpload}
                            disabled={saving}      // if you also want to disable during save
                        />
                    </UploadButton>
                    <ImagePreviewContainer>
                        {formData.images.map((img, index) => (
                            <ImagePreview key={index}>
                                <img
                                    src={img instanceof File ? URL.createObjectURL(img) : img}
                                    alt={`Preview ${index}`}
                                />
                                <RemoveImageButton onClick={() => removeImage(index)}>×</RemoveImageButton>
                            </ImagePreview>
                        ))}
                    </ImagePreviewContainer>

                    <Inline>
                        <div>
                            <Label>Name</Label>
                            <Input type="text" name="name" value={formData.name} onChange={handleChange} required />
                        </div>
                    </Inline>
                    <Inline>

                        <div>
                            <Label>Original Preis (€)</Label>
                            <Input type="number" name="orgPrice"  value={formData.orgPrice} onChange={handleChange} />
                        </div>
                        <div>
                            <Label>Aktuell Preis (€)</Label>
                            <Input type="number" name="acctPrice"  value={formData.acctPrice} onChange={handleChange} />
                        </div>
                        <div>
                            <Label>
                                <input
                                    type="checkbox"
                                    name="priceOnRequest"
                                    checked={formData.priceOnRequest || false}
                                    onChange={(e) => setFormData(prev => ({ ...prev, priceOnRequest: e.target.checked }))}
                                />
                                Preis auf Anfrage</Label>

                        </div>
                    </Inline>
                    <Inline>
                        <div>
                            <Label>Modell</Label>
                            <Select name="model" value={formData.model} onChange={handleChange}>
                                <option value="" disabled>Wählen Sie ein Modell</option>
                                {modelOptions.map((model, index) => (
                                    <option key={index} value={model}>{model}</option>
                                ))}
                            </Select>
                        </div>
                        <div>
                            <Label>Breite (cm)</Label>
                            <Input type="number" name="width" value={formData.width} onChange={handleChange} />
                        </div>
                        <div>
                            <Label>Länge (cm)</Label>
                            <Input type="number" name="height" value={formData.height} onChange={handleChange} />
                        </div>
                        {/*<div>*/}
                        {/*    <Label>Größe</Label>*/}
                        {/*    <Select name="size" value={formData.size} onChange={handleChange}>*/}
                        {/*        <option value="" disabled>Wählen Sie eine Größe</option>*/}
                        {/*        {sizeOptions.map((size, index) => (*/}
                        {/*            <option key={index} value={size}>{size}</option>*/}
                        {/*        ))}*/}
                        {/*    </Select>*/}
                        {/*</div>*/}
                        {/*<div>*/}
                        {/*    <Label>Verwendungszweck</Label>*/}
                        {/*    <Select name="usage" value={formData.usage} onChange={handleChange}>*/}
                        {/*        <option value="" disabled>Wählen Sie einen Verwendungszweck</option>*/}
                        {/*        {usageOptions.map((usage, index) => (*/}
                        {/*            <option key={index} value={usage}>{usage}</option>*/}
                        {/*        ))}*/}
                        {/*    </Select>*/}

                        {/*</div>*/}
                        {/*<div>*/}
                        {/*    <Label>Material</Label>*/}
                        {/*    <Select name="material" value={formData.material} onChange={handleChange}>*/}
                        {/*        <option value="" disabled>Wählen Sie ein Material</option>*/}
                        {/*        {materialOptions.map((material, index) => (*/}
                        {/*            <option key={index} value={material}>{material}</option>*/}
                        {/*        ))}*/}
                        {/*    </Select>*/}
                        {/*</div>*/}

                    </Inline>

                    <Inline>

                    </Inline>
                    {/*<Inline>*/}
                    {/*    <div>*/}
                    {/*        <Label>Herstellungsart</Label>*/}
                    {/*        <Select name="manufacturing" value={formData.manufacturing} onChange={handleChange}>*/}
                    {/*            <option value="" disabled>Wählen Sie eine Herstellungsart</option>*/}
                    {/*            {manufacturingOptions.map((manufacturing, index) => (*/}
                    {/*                <option key={index} value={manufacturing}>{manufacturing}</option>*/}
                    {/*            ))}*/}
                    {/*        </Select>*/}
                    {/*    </div>*/}
                    {/*    <div>*/}
                    {/*        <Label>Design</Label>*/}
                    {/*        <Select name="design" value={formData.design} onChange={handleChange}>*/}
                    {/*            <option value="" disabled>Wählen Sie ein Design</option>*/}
                    {/*            {designOptions.map((design, index) => (*/}
                    {/*                <option key={index} value={design}>{design}</option>*/}
                    {/*            ))}*/}
                    {/*        </Select>*/}
                    {/*    </div>*/}
                    {/*    <div>*/}
                    {/*        <Label>Farbe</Label>*/}
                    {/*        <Select name="color" value={formData.color} onChange={handleChange}>*/}
                    {/*            <option value="" disabled>Wählen Sie eine Farbe</option>*/}
                    {/*            {colorOptions.map((color, index) => (*/}
                    {/*                <option key={index} value={color}>{color}</option>*/}
                    {/*            ))}*/}
                    {/*        </Select>*/}
                    {/*    </div>*/}
                    {/*    <div>*/}
                    {/*        <br/>*/}
                    {/*    </div>*/}
                    {/*</Inline>*/}
                    {/*<Label>Kurzbeschreibung</Label>*/}
                    {/*<TextArea name="shortDescription" value={formData.shortDescription} onChange={handleChange}  />*/}

                    <Label>Detaillierte Beschreibung</Label>
                    <TextArea2 name="detailedDescription" value={formData.detailedDescription} onChange={handleChange} />

                    <ButtonGroup>
                        <SubmitButton type="submit" disabled={saving}>
                            {saving ? "Speichern..." : carpet ? "Speichern" : "Hinzufügen"}
                        </SubmitButton>
                        <CancelButton type="button" onClick={onClose}>Abbrechen</CancelButton>
                    </ButtonGroup>
                </form>
            </FormContainer>
        </ModalBackdrop>
    );
}



/* Styled Components */
const ModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  overflow: hidden; /* Prevents unnecessary scrolling on the background */
`;

const FormContainer = styled.div`
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 60%;
  //max-width: 500px;  /* Ensures it doesn’t get too wide on larger screens */
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 15px;

  max-height: 95vh; /* Limits height to 90% of the viewport */
  overflow-y: auto; /* Enables scrolling inside the modal when needed */

  @media (max-width: 768px) {
    width: 90%;
    max-width: 400px;
    max-height: 90vh; /* Slightly more height on mobile */
  }
`;

const Label = styled.label`
  font-weight: bold;
  display: block;
  margin-top: 10px;
`;
const Inline = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;
  align-items: center;

  div {
    flex: 1;
  }

  @media (max-width: 768px) {
    flex-direction: column; /* Stack inputs in mobile view */
    gap: 10px;
  }
`;

const Input = styled.input`
  width: 220px;
  padding: 8px;
  margin-top: 5px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 16px;
  &:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px #fff inset !important;
    -webkit-text-fill-color: #0B093B !important;
  }

  &:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0px 1000px #fff inset !important;
    -webkit-text-fill-color: #0B093B !important;
  }

  &:-webkit-autofill:hover {
    -webkit-box-shadow: 0 0 0px 1000px #fff inset !important;
    -webkit-text-fill-color: #0B093B !important;
  }

  @media (max-width: 768px) {
    font-size: 14px; /* Slightly smaller text for mobile */
  }
`;

const Select = styled.select`
  width: 240px;
  padding: 8px;
  margin-top: 5px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 16px;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

const TextArea = styled.textarea`
  width: 70%;
  height: 30px;
  padding: 8px;
  margin-top: 5px;
  border-radius: 5px;
  border: 1px solid #ccc;
`;
const TextArea2 = styled.textarea`
  width: 70%;
  height: 100px;
  padding: 8px;
  margin-top: 5px;
  border-radius: 5px;
  border: 1px solid #ccc;
`;

const ImageUpload = styled.div`
  input {
    margin-top: 10px;
  }
`;

/* Ensures scrolling inside image preview */
const ImagePreviewContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
  justify-content: center;


  @media (max-width: 768px) {
  }
`;

const ImagePreview = styled.div`
  position: relative;
  width: 80px;
  height: 80px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 5px;
  }

  @media (max-width: 768px) {
    width: 70px;
    height: 70px;
  }
`;

const RemoveImageButton = styled.button`
  position: absolute;
  top: -5px;
  right: -5px;
  background: red;
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  width: 20px;
  height: 20px;
  font-size: 14px;
  line-height: 1;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 10px;
  }
`;


const SubmitButton = styled.button`
  background: #7620FF;
  color: white;
  padding: 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  flex: 1;
  margin-right: 10px;
  font-size: 16px;

  &:hover {
    background: #580cd2;
  }

  @media (max-width: 768px) {
    width: 100%; /* Full width buttons on mobile */
    margin-right: 0;
  }
`;

const CancelButton = styled.button`
  background: #ccc;
  color: black;
  padding: 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  flex: 1;
  font-size: 16px;

  &:hover {
    background: #999;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

// at the bottom with your other styled components

// Hide the real file input
const HiddenFileInput = styled.input`
  display: none;
`;

// Styled label that acts like a button
const UploadButton = styled.label`
  display: inline-block;
  background: #7620FF;
  color: white;
  padding: 10px 16px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  transition: background 0.2s ease;

  &:hover {
    background: #580cd2;
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`;

// (you already have ImagePreviewContainer, etc.)
